import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const feedbacksService = {
    getAll,
    addOrUpdateTicket,
    checkNewExist,
    exportCSV,
    getPhotoLink,
};

function getAll(params, pageToken = null, pageSize = 25) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    const nextPageToken = pageToken ? `&pageToken=${pageToken}` : '';
    return fetch(`${BASE_URL}api/survey-responses/query?${nextPageToken}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function checkNewExist(query) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/survey-responses/new`, requestOptions).then(handleResponse);
}

function getPhotoLink(photoId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/survey-responses/photos/${photoId}`, requestOptions).then(handleResponse);
}

function addOrUpdateTicket(ticket, reviewId) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(ticket),
    };

    return fetch(`${BASE_URL}api/survey-responses/${reviewId}/tickets`, requestOptions).then(handleResponse);
}

function exportCSV(query, format = 'csv') {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/export/feedbacks?format=${format}`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.DataExported, { resource: 'feedbacks' }));
}
